// extracted by mini-css-extract-plugin
export default {"sectionTitle":"sectionTitle---M3_s6"};